// StringUtils.ts

import React from "react"

export function removeUSAFromString(input: string): string {
  if (input.endsWith(", USA")) {
    return input.slice(0, -5) // Removes the last 5 characters, which are ", USA"
  }
  return input
}

export const formatPhoneNumberString = (rawVal: string | null | undefined) => {
  let val = rawVal
  if (!val || val.length === 0 || (val.length === 1 && val.charAt(0) === "(")) {
    return ""
  }

  if (val.startsWith("+1")) {
    val = val.substring(2)
  }

  val = val.replace(/\D/g, "")
  if (val.length <= 3) {
    return `(${val}`
  }

  if (val.length <= 6) {
    return `(${val.substring(0, 3)}) ${val.substring(3)}`
  }

  if (val.length > 10) {
    val = val.substring(0, 10)
  }

  return `(${val.substring(0, 3)}) ${val.substring(3, 6)}-${val.substring(6)}`
}

export function isPhoneValidLength(phone: string | null | undefined): boolean {
  if (typeof phone !== "string" || phone === "") {
    return false
  }
  const digitsOnly = phone
    .split("")
    .filter((char) => "0123456789.".includes(char))
    .join("")
  return digitsOnly.length >= 10
}

export function isValidEmail(email: string): boolean {
  const regex = /^[\w-+.]+@([\w-]+\.)+[\w-]{2,20}$/
  return regex.test(email)
}

export function isAppleHiddenEmail(email: string | null | undefined) {
  if (!email) {
    return false
  }
  return email.endsWith("@privaterelay.appleid.com")
}

/**
 * Extracts text content from a React node, or returns the input if it's a string.
 * @param {React.ReactNode | string} content - The content to extract text from.
 * @returns {string} - The extracted text or the original string.
 */
export function extractText(content: React.ReactNode): string {
  // If the content is a string or a number (both are valid React children), return it as a string.
  if (typeof content === "string" || typeof content === "number") {
    return content.toString()
  }

  // If the content is an array, recursively apply extractText to each element and join the results.
  if (Array.isArray(content)) {
    return content.map(extractText).join("")
  }

  // If the content is a React element and has children, recurse into the children.
  if (React.isValidElement(content)) {
    const props = content.props as { children?: React.ReactNode }
    if (props.children) {
      return extractText(props.children)
    }
  }

  // If none of the above, return an empty string as fallback.
  return ""
}

export function stripLineBreaks(text: string): string {
  return text.replace(/\n/g, " ")
}

// Helper to convert a string to Title Case (capitalizes each word)
export const toTitleCase = (str: string) =>
  str
    .replace(/_/g, " ") // Replace underscores with spaces
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")
